import { Fragment } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@material-ui/core";
import useStyles from "./styles";

export const SuccessTablePolizas = ({ rows }) => {
  const classes = useStyles();

  const columns = [
    {
      field: "oficina",
      headerName: "Oficina",
      flex: 1,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "ramo",
      headerName: "Ramo",
      flex: 1,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "poliza",
      headerName: "Póliza",
      flex: 1,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "fechaCancelacion",
      headerName: "Fecha de cancelación",
      flex: 1.4,
      headerClassName: "header",
      headerAlign: "center",
    },
  ];

  return (
    <Fragment>
      <Typography variant="h6" color="primary">
        Pólizas para cancelar
      </Typography>
      <DataGrid
        columns={columns}
        rows={rows ?? []}
        className={classes.root}
        disableSelectionOnClick
        disableColumnMenu
        rowsPerPageOptions={[8]}
        pageSize={8}
        pagination
      />
    </Fragment>
  );
};
